import { SignupPageLayout } from '@shared/components/page-layout';
import { observer } from 'mobx-react';
import * as React from 'react';

import { LoginContents } from './login-contents';

const Login = observer(() => {
    return (
        <SignupPageLayout>
            <LoginContents />
        </SignupPageLayout>
    );
});

export default Login;
